export const adminSettingsMenuDef = [
  {
    id: "mySheetGeneralSettings",
    label: "OC_GENERAL_SETTINGS",
    roles: ["MyTimesheet.admin"],
  },
  {
    id: "mySheetProjectSettings",
    label: "MY_TIMESHEET_PROJECT",
    roles: ["MyTimesheet.admin"],
  },
  {
    id: "mySheetClientSettings",
    label: "MY_TIMESHEET_CLIENT",
    roles: ["MyTimesheet.admin"],
  },
  {
    id: "mySheetCostSettings",
    label: "OC_COST",
    roles: ["MyTimesheet.admin"],
  },
];
